exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".styles__root___Bmj9D {\n  padding: 10px;\n}", "", {"version":3,"sources":["/./src/components/ButtonBlock/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;CACf","file":"styles.css","sourcesContent":[".root {\n  padding: 10px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"root": "styles__root___Bmj9D"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&sourceMap&importLoaders=2&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/ButtonBlock/styles.css
// module id = 504
// module chunks = 0